var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[(_vm.zonas)?_c('div',{staticClass:"col-12 text-center"},[_c('RecintoComponent',{attrs:{"zonas":_vm.zonas,"zona_id":_vm.zona_id,"can_click":_vm.can_click,"popup_enabled":_vm.popup_enabled,"occupied":_vm.occupied,"place":_vm.place},on:{"clickZona":_vm.irAZona}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }